import { useEffect } from 'react';
import { useTour } from '@reactour/tour';

interface TourPersistenceProps {
  stepsLength: number;
}

export function TourPersistence({ stepsLength }: TourPersistenceProps) {
  const { currentStep, isOpen } = useTour();

  // Debug logging
  useEffect(() => {
    console.log(
      'TourPersistence - currentStep:',
      currentStep,
      'isOpen:',
      isOpen
    );
  }, [currentStep, isOpen]);

  // Save current step to localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log('Saving step to localStorage:', currentStep);
      localStorage.setItem('samplesTourStep', currentStep.toString());
    }
  }, [currentStep]);

  // Check for completion when tour closes
  useEffect(() => {
    if (!isOpen && typeof window !== 'undefined') {
      const currentStepValue = parseInt(
        localStorage.getItem('samplesTourStep') || '0'
      );
      console.log(
        'Tour closed, checking completion. CurrentStep:',
        currentStepValue,
        'StepsLength:',
        stepsLength
      );
      if (currentStepValue >= stepsLength - 1) {
        console.log('Tour completed! Marking as complete.');
        localStorage.setItem('samplesTourCompleted', 'true');
        localStorage.setItem('samplesTourStep', '0'); // Reset to beginning for next time
      }
    }
  }, [isOpen, stepsLength]);

  return null; // This component doesn't render anything
}
